<template>
    <div class="content">
        <div class="section">
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>订单信息</span>
                </div>
            </div>
            <div class="info">
                <div class="data">团队订单编号：{{ content.orderSn }}</div>
                <div class="data" v-if="content.orderDetailInfoVOList">
                    入馆日期：{{ content.orderDetailInfoVOList[0].playStartDay }}
                    {{ content.orderDetailInfoVOList[0].startTime }}-{{
                        content.orderDetailInfoVOList[0].endTime
                    }}
                </div>
                <div class="data flex-row">
                    订单状态：<span style="color: #bb2916; font-weight: 600">审核通过/待支付</span>
                    <div class="tip">
                        重要提醒：审核通过后需及时支付订单金额，否则将超时自动取消，详细问题请联系客服
                    </div>
                    <div class="cancelbtn cursorp" @click="CancelOrder">取消预约</div>
                </div>
                <div class="data">
                    订单金额：
                    <span class="price" style="color: #bb2916">￥{{ content.totalAmount }}</span>
                </div>
            </div>
            <div class="table">
                <div class="tableHeader flex-row">
                    <div class="item name">参观团队</div>
                    <div class="item">领队人员</div>
                    <div class="item idCard">证件号码</div>
                    <div class="item phone">联系电话</div>
                    <div class="item">门票名称</div>
                    <div class="item">参观总数</div>
                    <div class="item">人员名单</div>
                </div>
                <div class="tBody">
                    <div
                        class="th flex-row"
                        v-for="(item, index) in content.orderDetailInfoVOList"
                        :key="index"
                    >
                        <div class="data name ellipsis1">
                            {{ content.teamName }}
                        </div>
                        <div class="data">
                            {{ content.contact }}
                        </div>
                        <div class="data idCard">
                            {{ content.customerIdCard }}
                        </div>
                        <div class="data phone">
                            {{ content.contactNumber }}
                        </div>
                        <div class="data">
                            {{ item.productName }}
                        </div>
                        <div class="data">
                            {{ item.productQuantity }}
                        </div>
                        <div
                            class="data cursorp"
                            style="color: #bb2916; text-decoration: underline"
                            @click="showPerson(item.museumOrderUserVOS)"
                        >
                            点击查看
                        </div>
                    </div>
                </div>
            </div>
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>支付方式</span>
                </div>
            </div>
            <div class="paymode flex-row">
                <div class="item">
                    <el-radio v-model="payMethod" label="webPayIcbc">
                        <img src="../../assets/img/icon-juhe.png" /> 聚合支付</el-radio
                    >
                </div>
                <!-- <div class="item">
					<el-radio v-model="radio" label="2"> <img src='../../assets/img/icon-wechat.png'> 微信支付</el-radio>
				</div>
				<div class="item">
					<el-radio v-model="radio" label="3"> <img src='../../assets/img/icon-Alipay.png'> 支付宝支付</el-radio>
				</div> -->
                <div class="item">
                    <el-radio v-model="payMethod" label="webPayE">
                        <img src="../../assets/img/icon-rmb.png" /> 数字人民币</el-radio
                    >
                </div>
            </div>
            <div class="tag flex-row">
                <div class="flex-column">
                    <img src="../../assets/img/btzs-icon.png" />
                    <span>温馨提示</span>
                </div>
            </div>
            <div class="detail">
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    团队需至少提前三天在四川大学博物馆官网或微信公众号预约购票，到团当日无法预约当天票。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    参观日请联系人提前组织好团队，按照二维码下方的进场时间从团队入口有序扫码进场，超过预约时间30分钟，二维码失效，无法入场。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    开馆时间:09:00，停止入馆时间:16:30，闭馆时间:17:00。
                </div>
                <div class="item flex-row">
                    <img src="../../assets/img/icon-tip1.png" />
                    咨询电话028-85412543，028-85400772。
                </div>
            </div>
            <img class="line" src="../../assets/img/icon-line.svg" />
            <div class="btnbox flex-row">
                <div class="backbtn cursorp" @click="toPage">返回</div>
                <div class="prevbtn cursorp" @click="NowPayment">立即支付</div>
            </div>
        </div>
        <!-- 人员名单弹窗 -->
        <PersonList
            :isShowPerson="isShowPerson"
            :tableData="list"
            @changeDialog="getData"
        ></PersonList>
    </div>
</template>

<script>
import { getOrderDetail, merchantNo, CancelOrder, doKeepPaying } from "../../utils/http.js";
import PersonList from "@/components/Dialog/PersonList.vue"; //人员名单列表
export default {
    name: "TeamUsed",
    components: {
        PersonList,
    },
    data() {
        return {
            list: [],
            payMethod: "", //支付方式
            isShowPerson: false,
            content: {},
        };
    },
    mounted() {
        let orderNo = this.$route.query.orderNo;
        this.getOrderDetail({
            orderSn: orderNo,
        });
    },
    methods: {
        // 获取订单详情
        getOrderDetail(param) {
            getOrderDetail(param).then(res => {
                this.content = res.data;
            });
        },
        // 取消预约
        CancelOrder() {
            let that = this;
            this.$confirm("是否确认取消预约?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                customClass: "confirm",
                type: "warning",
            })
                .then(() => {
                    let param = {
                        merchantNo: merchantNo, //商户号
                        orderSn: that.content.orderSn, //订单号
                    };
                    CancelOrder(param).then(res => {
                        this.$message({
                            message: "取消成功",
                            type: "success",
                            offset: "400",
                            duration: "1000",
                        });
                        setTimeout(() => {
                            // 返回上一页并且刷新页面
                            this.$router.go(-1);
                        }, 1500);
                    });
                })
                .catch(() => {});
        },
        // 点击立即支付
        NowPayment() {
            if (this.payMethod == "") {
                this.$message({
                    message: "请选择支付方式！",
                    type: "error",
                    offset: "400",
                    duration: "1000",
                });
                return;
            }
            let param = {
                orderNo: this.content.orderSn,
                payType: 4,
                payConfigType: 4,
                tradeType: this.payMethod, //支付方式
                payReturnUrl: "https://guanwang.sxd.cn/#/MyCenter",
            };
            doKeepPaying(param).then(res => {
                // 跳转支付页面
                window.open(res.data.payUrl, "_blank");
            });
        },
        //点击返回
        toPage() {
            this.$router.back();
        },
        // 点击查看人员名单
        showPerson(list) {
            this.isShowPerson = true;
            this.list = list;
        },
        // 获取子组件传递的值
        getData(val) {
            this.isShowPerson = val;
        },
    },
};
</script>

<style scoped>
.content {
    width: 1200px;
    margin: auto;
    background: #fff;
    background-size: 100%;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    padding: 24px;
    box-sizing: border-box;
}

.section {
    width: 100%;
}

.section .info {
    width: 1007px;
    margin-left: 60px;
    margin-bottom: 8px;
    position: relative;
}

.section .info .data {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
    margin-bottom: 20px;
    position: relative;
}

.info .tip {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #bb2916;
    height: 24px;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #bb2916;
    line-height: 24px;
    margin-left: 10px;
    padding: 0 6px;
    box-sizing: border-box;
}

.info .cancelbtn {
    width: 92px;
    height: 38px;
    background: #ffffff;
    border-radius: 30px;
    border: 1px solid #bb2916;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #bb2916;
    line-height: 38px;
    text-align: center;
    position: absolute;
    top: 0;
    right: 0;
}

.info .price {
    font-size: 20px;
    font-weight: 600;
}

.section .table {
    width: 1007px;
    padding: 0 60px;
    box-sizing: border-box;
    margin-bottom: 24px;
}

.table .tableHeader {
    width: 1007px;
    height: 64px;
    border-radius: 6px 6px 0px 0px;
    background-image: url("../../assets/img/tableBG.svg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    justify-content: space-between;
}

.table .tableHeader .item {
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    width: 127px;
    text-align: center;
}

.table .name,
.idCard,
.phone {
    width: 187px !important;
}

.table .tBody {
    width: 1007px;
    border: 1px solid #f1f1f1;
}

.table .tBody .th {
    width: 100%;
    height: 63px;
    background: #ffffff;
    justify-content: space-between;
    border-bottom: 1px solid #f1f1f1;
}

.table .tBody .th:last-child {
    border: none !important;
}

.tBody .data span {
    display: block;
    width: 60px;
    height: 23px;
    background: #bb2916;
    border-radius: 6px;
    font-size: 12px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-left: 7px;
    line-height: 23px;
}

.tBody .th .data {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    width: 127px;
    text-align: center;
    padding: 0 6px;
    box-sizing: border-box;
    justify-content: center;
}

.returnTicket {
    color: #999999 !important;
}

.section .paymode {
    padding: 0 60px;
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 24px;
}

.section .paymode .item {
    margin-right: 16px;
}

.section .paymode .item img {
    width: 48px;
    height: 48px;
    margin-right: 14px;
}

.section .detail {
    margin: 24px 0;
    margin-left: 60px;
}

.detail .item {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    margin-bottom: 20px;
}

.detail .item img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
}

.line {
    width: 1038px;
    height: 6px;
    margin: 24px 0;
    margin-left: 60px;
}

.btnbox {
    justify-content: center;
}

.btnbox div {
    width: 324px;
    height: 60px;
    font-size: 22px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 60px;
    border-radius: 30px;
}

.btnbox .backbtn {
    color: #bb2916;
    background: #ffffff;
    border: 1px solid #bb2916;
    margin-right: 32px;
}

.btnbox .prevbtn {
    color: #ffffff;
    background: #bb2916;
}

/deep/ .el-radio {
    display: flex;
    flex-direction: row;
    align-items: center;
}

/deep/.el-radio .el-radio__label {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #000;
}

/deep/ .el-radio__inner {
    width: 20px;
    height: 20px;
    background: #f3f3f3;
    border: 2px solid #bb2916;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #bb2916;
    background: #bb2916;
}

/deep/.el-radio__input.is-checked + .el-radio__label {
    color: #bb2916;
}
</style>
